import { isGooglePlacesLoaded } from '#utils/googleMaps';

export const googleAutocomplete = async (text: string) =>
  new Promise((resolve, reject) => {
    if (!text) {
      return reject('Need valid text input');
    }

    if (typeof window === 'undefined') {
      return reject('Need valid window object');
    }

    if (!isGooglePlacesLoaded()) {
      return reject('Google Maps API not loaded');
    }

    try {
      new window.google.maps.places.AutocompleteService().getPlacePredictions({ input: text }, resolve);
    } catch (e) {
      reject(e);
    }
  });

export const getCoordinateById = async (placeId: string) =>
  new Promise((resolve, reject) => {
    if (!placeId) {
      return reject('Need valid text input');
    }

    if (typeof window === 'undefined') {
      return reject('Need valid window object');
    }

    if (!isGooglePlacesLoaded()) {
      return reject('Google Maps API not loaded');
    }

    try {
      if (document.getElementById('map')) {
        new window.google.maps.places.PlacesService(document.getElementById('map') as HTMLDivElement).getDetails(
          { placeId: placeId },
          resolve
        );
      }
    } catch (e) {
      reject(e);
    }
  });
